/**
 * Robust API payload unwrapper that handles various transport envelope formats
 * and parses JSON strings to extract the actual data payload.
 */
export function unwrapApiPayload(input: any) {
  let p = (input as any)?.Data ?? (input as any)?.data ?? input;
  if (typeof p === 'string') {
    try { p = JSON.parse(p); } catch {}
  }
  return (p as any)?.results ?? p; // returns canonical object
}
